import { apiSlice } from './apiSlice'

import type { LongShortRow } from './dashboardLongShortApi'

/**
 * Inventory dashboard data — `GET /api/v1/dashboard/inventory`.
 *
 * Mirrors FastAPI `InventoryDashboardResponse` (camelCase aliases). BE returns
 * DATA ROWS only; column/format config lives in `pages/dashboard/inventory/`.
 * Source: Report DB (`DATABASE_URL_REPORT`). Spec: plan/Inventory_Dashboard_BE_Proposal.md.
 *
 * No date params: the PBI page "Inventory" has no date slicer — point-in-time.
 * Row shape dùng chung `LongShortRow` (values[warehouse][measureKey]).
 */
export interface InventoryDashboardResponse {
  /** PBI report_date card — ISO `YYYY-MM-DD`. */
  reportDate: string | null
  /** Ordered column groups: 4 warehouse (page filter PBI) + "Total" cuối. */
  warehouses: string[]
  /** Rows: category (Grade subtotal) → code → grand Total. Measures:
   *  receiveSp, issue, receivePro, shipped, stock. */
  rows: LongShortRow[]
}

const dashboardInventoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInventoryDashboard: builder.query<InventoryDashboardResponse, void>({
      query: () => ({ url: '/dashboard/inventory' }),
    }),
  }),
})

export const { useGetInventoryDashboardQuery } = dashboardInventoryApi
